import React from 'react';
import { Box } from '@mui/material';
import Chart from 'react-apexcharts';
import NoDataOnChart from './NoDataOnChart';
import ZoomResetView from './ZoomResetView';

const BaseVitalChart = ({
    options,
    series,
    primaryGranularity,
    chartHeight,
    resetToLatestDataDate,
    isDataSeriesEmpty,
    chartID,
    zoomResetViewRef,
    disableZoomReset = false,
    chartProps = {},
    chartKey = '',
    disableRedirect = false,
    noDataMessage = 'No data available for the selected date',
    onZoomReset = () => {},
    isZoomed = null
}) => {
    return (
        <Box sx={{ position: 'relative' }}>
            {!disableZoomReset && <ZoomResetView ref={zoomResetViewRef} chartID={chartID} onReset={onZoomReset} isZoomedProp={isZoomed} />}
            <NoDataOnChart
                onClick={() => resetToLatestDataDate()}
                isDataEmpty={isDataSeriesEmpty?.() ?? false}
                disableRedirect={disableRedirect}
                noDataMessage={noDataMessage}
            />
            <Box>
                <Chart
                    id={primaryGranularity === 'raw' ? "hideAlternateLabel" : 'donthide'}
                    options={options}
                    series={series}
                    type="line"
                    height={chartHeight}
                    key={chartKey}
                    {...chartProps}
                />
            </Box>
        </Box>
    );
};

export default BaseVitalChart;
